import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=415cd99a&scoped=true"
import script from "./FormAlert.vue?vue&type=script&lang=js"
export * from "./FormAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415cd99a",
  null
  
)

export default component.exports